import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { MainContext } from '@blaze-cms/nextjs-components';
import { getSingleEntitySchema } from '../../application/query';
import { buildPropsQuery, checkPropsToUse } from '../../helpers';
import { getDataSummaryQuery, getLinkProps } from './helpers';
import DataSummaryRender from './DataSummaryRender';

const DataSummaryFactory = ({
  entity,
  dataRecordId,
  propsToDisplay,
  type,
  useSelectedEntity,
  elementTitle,
  modifier,
  headingStyle,
  loopProperties,
  loopLimit,
  variant,
  VariantComponent,
  parent
}) => {
  const entityForQuery = useSelectedEntity ? entity : parent.itemEntity;
  const { data, error, loading } = useQuery(getSingleEntitySchema, {
    variables: { id: entityForQuery }
  });

  const { isPreview } = useContext(MainContext);
  if (loading) return '';
  if (error) return error.message;
  if (!data) return null;
  if (!propsToDisplay || !propsToDisplay.length) return null;
  const propsToDisplayValues = checkPropsToUse(propsToDisplay);
  const linkProps = getLinkProps(propsToDisplay);
  const propsQueryString = buildPropsQuery(data, propsToDisplayValues, null, linkProps);
  const dataSummaryQuery = getDataSummaryQuery(data, isPreview, propsQueryString);
  const recordId = dataRecordId[0] || parent.itemId;
  const isSlider = variant === 'slideSummary';

  return (
    <DataSummaryRender
      recordId={recordId}
      propsToDisplay={propsToDisplay}
      loopProperties={loopProperties}
      loopLimit={loopLimit}
      query={dataSummaryQuery}
      type={type}
      elementTitle={elementTitle}
      modifier={modifier}
      htmlTag={headingStyle}
      variant={variant}
      VariantComponent={VariantComponent}
      isSlider={isSlider}
    />
  );
};

DataSummaryFactory.propTypes = {
  parent: PropTypes.object.isRequired,
  type: PropTypes.string,
  dataRecordId: PropTypes.array,
  propsToDisplay: PropTypes.array,
  entity: PropTypes.string,
  useSelectedEntity: PropTypes.bool,
  elementTitle: PropTypes.string,
  modifier: PropTypes.string,
  headingStyle: PropTypes.string,
  loopProperties: PropTypes.array,
  loopLimit: PropTypes.number,
  variant: PropTypes.string,
  VariantComponent: PropTypes.func
};

DataSummaryFactory.defaultProps = {
  type: 'text',
  dataRecordId: [],
  propsToDisplay: [],
  useSelectedEntity: true,
  entity: '',
  elementTitle: '',
  modifier: '',
  headingStyle: 'h2',
  loopProperties: [],
  loopLimit: 0,
  variant: null,
  VariantComponent: null
};

export default DataSummaryFactory;
